import { render, staticRenderFns } from "./SettingsEmbed.vue?vue&type=template&id=1f1e989e&"
import script from "./SettingsEmbed.vue?vue&type=script&lang=js&"
export * from "./SettingsEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports